import React from 'react';
import { useI18n } from '../../../../contexts/I18nContext';
import VideoOptionsSelector from '../VideoOptionsSelector';

const ImageToVideoControls = ({
  prompt,
  setPrompt,
  model,
  setModel,
  mode,
  setMode,
  ratio,
  setRatio,
  resolution,
  setResolution,
  duration,
  setDuration,
  modelOptions,
  modeOptions,
  ratioOptions,
  resolutionOptions,
  durationOptions,
  credits,
  isGenerating,
  generationProgress,
  canGenerate,
  handleGenerate
}) => {
  const { t, language } = useI18n();
  const settingsTitle = language === 'en' ? 'Video Settings' : language === 'zh-TW' ? '影片設定' : '视频设置';

  return (
    <div className="veo2-form__panel">
      <div className="veo2-section">
        <div className="veo2-section__header">
          <div className="veo2-section__title">{t('videoGeneration.veo.common.prompt')}</div>
          <div className="veo2-count">{`${prompt.length} / 2000`}</div>
        </div>
        <div className="veo2-divider" />
        <textarea
          className="veo2-input"
          placeholder={t('videoGeneration.veo.common.promptPlaceholder')}
          maxLength={2000}
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
        />
      </div>

      <VideoOptionsSelector
        title={settingsTitle}
        model={model}
        videoMode={mode}
        aspectRatio={ratio}
        videoResolution={resolution}
        videoDuration={duration}
        modelOptions={modelOptions}
        videoModeOptions={modeOptions}
        aspectRatioOptions={ratioOptions}
        videoResolutionOptions={resolutionOptions}
        videoDurationOptions={durationOptions}
        onModelChange={setModel}
        onVideoModeChange={setMode}
        onAspectRatioChange={setRatio}
        onVideoResolutionChange={setResolution}
        onVideoDurationChange={setDuration}
      />

      <div className="veo2-actions">
        {typeof credits === 'number' && credits > 0 && (
          <div className="veo2-credits">
            <div className="veo2-credits__bar">
              <span>{t('videoGeneration.veo.common.creditsBar')}</span>
              <span className="veo2-credits__value">{t('videoGeneration.veo.common.creditsValue', { count: credits })}</span>
            </div>
          </div>
        )}
        <button
          className={`veo2-generate ${isGenerating ? 'generating' : canGenerate ? 'is-ready' : 'is-disabled'}`}
          onClick={handleGenerate}
          disabled={isGenerating || !canGenerate}
          style={isGenerating ? { '--progress': generationProgress } : undefined}
        >
          {isGenerating
            ? `${t('aiToolTemplate.generating')} ${Math.round(generationProgress)}% (${typeof credits === 'number' ? credits : 0} ${t('credits.credits')})`
            : `${typeof credits === 'number' ? t('videoGeneration.veo.common.generateButton', { count: credits }) : t('aiToolTemplate.startGeneration')}`}
        </button>
      </div>
    </div>
  );
};

export default ImageToVideoControls;
